module.exports = __webpack_public_path__ + "img/nerve.64219db9.svg";